/* eslint-disable react-hooks/exhaustive-deps */
import { Grid, Divider } from "@mui/material";
import React, { useState, useEffect } from "react";
import { StyledDeviceDetailForm } from "./checkSerialNumber.style";
import Typography from "component/commonComponents/Typography";
import TextBox from "component/commonComponents/Textbox";
import parse from 'html-react-parser';

export interface IDeviceDetailsProps {
    open?: boolean;
    dataSearchSN: any;
    detailsForm: any;
    isManualInput?: boolean;
    kbNumber: string;
    valueInput: string;
    disabledRequired?: boolean;
    cleanData?: boolean;
    locale?: any; // object
    textShow?:any;
    isSpecialCharacterAllowed?: boolean;
}

const DeviceDetailsForm: React.FC<IDeviceDetailsProps> = (props) => {
  const {
    open,
    dataSearchSN,
    detailsForm,
    isManualInput,
    valueInput,
    cleanData,
    locale,
    textShow,
    isSpecialCharacterAllowed
  } = props;

  const [deviceDetailsForm, setDeviceDetailsForm] = useState({
    sys_id: '',
    serial_number: '',
    manufacturer: '',
    model: '',
    account_name: '',
    model_number: '',
    po_number: '',
    asset_tag: '',
    comments: '',
  });

  const handleChangeInput = (e: any) => {
    setDeviceDetailsForm({
        ...deviceDetailsForm,
        [e.target.name]: e.target.value,
    })
    detailsForm({
      ...deviceDetailsForm,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    if (!!cleanData && dataSearchSN?.uid) {
      setDeviceDetailsForm({
        ...deviceDetailsForm,

        sys_id: dataSearchSN?.uid || '',
        serial_number:  dataSearchSN?.serial_number || valueInput,
        manufacturer: dataSearchSN?.manufacturer || deviceDetailsForm.manufacturer,
        model: dataSearchSN?.model || deviceDetailsForm.model,
        account_name: dataSearchSN?.account_name || deviceDetailsForm.account_name,
        model_number: dataSearchSN?.model_number || deviceDetailsForm.model_number,
        po_number: dataSearchSN?.po_number || deviceDetailsForm.po_number,
        asset_tag: dataSearchSN?.asset_tag || deviceDetailsForm.asset_tag,
        comments: dataSearchSN?.comments || deviceDetailsForm.comments,
      });
      detailsForm({
        sys_id: dataSearchSN?.uid || '',
        serial_number:  dataSearchSN?.serial_number || valueInput,
        manufacturer: dataSearchSN?.manufacturer || deviceDetailsForm.manufacturer,
        model: dataSearchSN?.model || deviceDetailsForm.model,
        account_name: dataSearchSN?.account_name || deviceDetailsForm.account_name,
        model_number: dataSearchSN?.model_number || deviceDetailsForm.model_number,
        po_number: dataSearchSN?.po_number || deviceDetailsForm.po_number,
        asset_tag: dataSearchSN?.asset_tag || deviceDetailsForm.asset_tag,
        comments: dataSearchSN?.comments || deviceDetailsForm.comments
      });
      return;
    }
    if(!!cleanData && dataSearchSN) {
      setDeviceDetailsForm({
        sys_id: '',
        serial_number: '',
        manufacturer: '',
        model: '',
        account_name: '',
        model_number: '',
        po_number: '',
        asset_tag: '',
        comments: '',
      });
      detailsForm({
        sys_id: '',
        serial_number: '',
        manufacturer: '',
        model: '',
        account_name: '',
        model_number: '',
        po_number: '',
        asset_tag: '',
        comments: '',
    });
    } else if (dataSearchSN !== null && !cleanData ) {
        setDeviceDetailsForm({
            ...deviceDetailsForm,
            sys_id: dataSearchSN?.uid || '',
            serial_number:  dataSearchSN?.serial_number || valueInput,
            manufacturer: dataSearchSN?.manufacturer || deviceDetailsForm.manufacturer,
            model: dataSearchSN?.model || deviceDetailsForm.model,
            account_name: dataSearchSN?.account_name || deviceDetailsForm.account_name,
            model_number: dataSearchSN?.model_number || deviceDetailsForm.model_number,
            po_number: dataSearchSN?.po_number || deviceDetailsForm.po_number,
            asset_tag: dataSearchSN?.asset_tag || deviceDetailsForm.asset_tag,
            comments: dataSearchSN?.comments || deviceDetailsForm.comments,
        });
        detailsForm({
          sys_id: dataSearchSN?.uid || '',
          serial_number:  dataSearchSN?.serial_number || valueInput,
          manufacturer: dataSearchSN?.manufacturer || deviceDetailsForm.manufacturer,
          model: dataSearchSN?.model || deviceDetailsForm.model,
          account_name: dataSearchSN?.account_name || deviceDetailsForm.account_name,
          model_number: dataSearchSN?.model_number || deviceDetailsForm.model_number,
          po_number: dataSearchSN?.po_number || deviceDetailsForm.po_number,
          asset_tag: dataSearchSN?.asset_tag || deviceDetailsForm.asset_tag,
          comments: dataSearchSN?.comments || deviceDetailsForm.comments
        });
    } else {
      setDeviceDetailsForm({
        sys_id: '',
        serial_number: '',
        manufacturer: '',
        model: '',
        account_name: '',
        model_number: '',
        po_number: '',
        asset_tag: '',
        comments: '',
      });
      detailsForm({
        sys_id: '',
        serial_number: '',
        manufacturer: '',
        model: '',
        account_name: '',
        model_number: '',
        po_number: '',
        asset_tag: '',
        comments: '',
    });
    }

  },[dataSearchSN, valueInput, cleanData]);

  return (
    <>
        {open &&
        <StyledDeviceDetailForm>
        <Grid container xs={12} item className="SN-device-details">
            <Grid xs={12} item className="divider">
                <Divider></Divider>
            </Grid>
            <Grid xs={12} item className="device-details-title">
            <Typography>{locale?.deviceDetails}</Typography>
            </Grid>
            <TextBox
                textboxToolTip={locale?.textboxToolTip}
                isShow={false}
                label={locale?.serialNumber}
                name="serial_number"
                boldLabel
                isSpecialCharacterAllowed={isSpecialCharacterAllowed}
                value={deviceDetailsForm.serial_number}
                onChange={(e: any) => handleChangeInput(e)}
            />
            <Grid xs={12} md={12} lg={6} item className="text-input">
              {isManualInput && props.disabledRequired?
               <TextBox
                textboxToolTip={locale?.textboxToolTip}
                label={locale?.manufacturer}
                name="manufacturer"
                required={true}
                disabled={false}
                boldLabel
                isSpecialCharacterAllowed={isSpecialCharacterAllowed}
                value={deviceDetailsForm.manufacturer}
                onChange={(e: any) => handleChangeInput(e)}
                /> :
              <TextBox
                  textboxToolTip={locale?.textboxToolTip}
                  label={locale?.manufacturer}
                  name="manufacturer"
                  required={true}
                  disabled={true}
                  boldLabel
                  isSpecialCharacterAllowed={isSpecialCharacterAllowed}
                  value={deviceDetailsForm.manufacturer}
                  onChange={(e: any) => handleChangeInput(e)}
              />}
            </Grid>
            <Grid xs={12} md={12} lg={6} item className="text-input">
            {isManualInput && props.disabledRequired?
             <TextBox
                textboxToolTip={locale?.textboxToolTip}
                label={locale?.modelName}
                name="model"
                required={true}
                disabled={false}
                boldLabel
                isSpecialCharacterAllowed={isSpecialCharacterAllowed}
                value={deviceDetailsForm.model}
                onChange={(e: any) => handleChangeInput(e)}
                />
                :
              <TextBox
                textboxToolTip={locale?.textboxToolTip}
                label={locale?.modelName}
                name="model"
                required={true}
                disabled={true}
                boldLabel
                isSpecialCharacterAllowed={isSpecialCharacterAllowed}
                value={deviceDetailsForm.model}
                onChange={(e: any) => handleChangeInput(e)}
                />}
            </Grid>
            <Grid xs={12} md={12} lg={6} item className="text-input">
            <TextBox
                textboxToolTip={locale?.textboxToolTip}
                label={locale?.accountName}
                name="account_name"
                boldLabel
                isSpecialCharacterAllowed={isSpecialCharacterAllowed}
                value={deviceDetailsForm.account_name}
                onChange={(e: any) => handleChangeInput(e)}
            />
            </Grid>
            <Grid xs={12} md={12} lg={6} item className="text-input">
            {isManualInput && props.disabledRequired?
                <TextBox
                  textboxToolTip={locale?.textboxToolTip}
                  label={locale?.modelPartNumber}
                  name="model_number"
                  disabled={false}
                  boldLabel
                  isSpecialCharacterAllowed={isSpecialCharacterAllowed}
                  value={deviceDetailsForm.model_number}
                  onChange={(e: any) => handleChangeInput(e)}
              />  :
              <TextBox
                  textboxToolTip={locale?.textboxToolTip}
                  label={locale?.modelPartNumber}
                  name="model_number"
                  disabled={true}
                  boldLabel
                  isSpecialCharacterAllowed={isSpecialCharacterAllowed}
                  value={deviceDetailsForm.model_number}
                  onChange={(e: any) => handleChangeInput(e)}
              />}
            </Grid>
            <Grid xs={12} md={12} lg={6} item className="text-input">
            <TextBox
                textboxToolTip={locale?.textboxToolTip}
                label={locale?.poNumber}
                name="po_number"
                boldLabel
                isSpecialCharacterAllowed={isSpecialCharacterAllowed}
                value={deviceDetailsForm.po_number}
                onChange={(e: any) => handleChangeInput(e)}
            />
            </Grid>
            <Grid xs={12} md={12} lg={6} item className="text-input">
            {isManualInput && props.disabledRequired?
             <TextBox
                textboxToolTip={locale?.textboxToolTip}
                label={locale?.assetTag}
                name="asset_tag"
                disabled={false}
                boldLabel
                isSpecialCharacterAllowed={isSpecialCharacterAllowed}
                value={deviceDetailsForm.asset_tag}
                onChange={(e: any) => handleChangeInput(e)}
                /> :
            <TextBox
                textboxToolTip={locale?.textboxToolTip}
                label={locale?.assetTag}
                name="asset_tag"
                disabled={true}
                boldLabel
                isSpecialCharacterAllowed={isSpecialCharacterAllowed}
                value={deviceDetailsForm.asset_tag}
                onChange={(e: any) => handleChangeInput(e)}
            />}
            </Grid>
            <Grid xs={12} md={12} lg={6} item className="text-input">
            <TextBox
                textboxToolTip={locale?.textboxToolTip}
                label={locale?.comments}
                name="comments"
                multiline={true}
                rows={3}
                boldLabel
                isSpecialCharacterAllowed={isSpecialCharacterAllowed}
                value={deviceDetailsForm.comments}
                onChange={(e: any) => handleChangeInput(e)}
            />
            </Grid>
            <Grid xs={12} md={12} lg={12} item className="text-show">
              <Typography>{parse(textShow)}</Typography>
            </Grid>
        </Grid>
      </StyledDeviceDetailForm>
      }

    </>
  );
};

DeviceDetailsForm.defaultProps = {
  open: false,
  isManualInput: false,
  kbNumber: '',
  valueInput: '',
  disabledRequired: false,
  cleanData: false,
  locale: {
    deviceDetails: 'Device Details',
    serialNumber: 'Serial Number',
    manufacturer: 'Manufacturer',
    modelName: 'Model Name',
    accountName: 'Account Name',
    modelPartNumber: 'Model Part Number',
    poNumber: 'PO Number',
    assetTag: 'Asset Tag',
    comments: 'Comments',
    kbLinkText: 'Click here to visit the KB link for more details.',
  },
};

export default DeviceDetailsForm;
